import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
const Page = lazy(() => import("@/features/sub-orders/take-of-care/page-client"));
export const Route = createFileRoute("/_authed/agent/sub/orders/take-of-care")({
  component: () => (
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  ),
});
